import { render, staticRenderFns } from "./ReplyTemplatesDialog.vue?vue&type=template&id=5de91ba6&scoped=true&"
import script from "./ReplyTemplatesDialog.vue?vue&type=script&lang=js&"
export * from "./ReplyTemplatesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReplyTemplatesDialog.vue?vue&type=style&index=0&id=5de91ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de91ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
